export const isUniversity = ({ mokykla_status }) => mokykla_status === 0;
